import { RateCardsConfigTabOption } from "../../../../../../types"

export interface RateCardLoanTypeOption {
  key: string
  label: string
}

export const LOAN_TYPE_LABEL_MAP: Record<string, string> = {
  thirty_year: "30 Year Fixed",
  fifteen_year: "15 Year Fixed",
  arm: "ARM",
  fha: "FHA",
  va: "VA",
  usda: "USDA",
  thirty_year_jumbo: "30 Year Jumbo",
  fifteen_year_jumbo: "15 Year Jumbo",
  jumbo_arm: "Jumbo ARM",
  thirty_year_ldp: "30 Year LDP",
  fifteen_year_ldp: "15 Year LDP",
  va_ldp: "VA LDP",
  va_zdp: "VA ZDP",
  fifteen_year_va: "15 Year VA",
  fifteen_year_va_ldp: "15 Year VA LDP",
  fifteen_year_va_zdp: "15 Year VA ZDP",
  thirty_year_refi: "30 Year Refinance",
  fifteen_year_refi: "15 Year Refinance",
  arm_refi: "ARM Refinance",
  fha_refi: "FHA Refinance",
  va_refi: "VA Refinance"
}

export const formatKey = (key: string) =>
  key.replace(/_/g, " ").replace(/\b\w/g, c => c.toUpperCase())

export const isRefi = (key: string) => key.endsWith("_refi")

export const toLoanTypes = (keys: string[]) =>
  keys.map(key => ({ key, label: LOAN_TYPE_LABEL_MAP[key] ?? formatKey(key) }))

export const toDefaultTabOptions = (loanTypes: RateCardLoanTypeOption[]) =>
  loanTypes.map(lt => ({ type: lt.key, label: lt.label }))

export const orderLoanTypesForDisplay = (
  loanTypes: RateCardLoanTypeOption[],
  selectedTabs: RateCardsConfigTabOption[]
) => {
  const loanTypeByKey = new Map(loanTypes.map(lt => [lt.key, lt]))
  const selectedKeys = new Set(selectedTabs.map(tab => tab.type))
  const selectedLoanTypes = selectedTabs
    .map(tab => loanTypeByKey.get(tab.type))
    .filter((lt): lt is RateCardLoanTypeOption => Boolean(lt))
  const unselectedLoanTypes = loanTypes.filter(lt => !selectedKeys.has(lt.key))

  return [...selectedLoanTypes, ...unselectedLoanTypes]
}

export const moveTabOption = (
  tabs: RateCardsConfigTabOption[],
  type: string,
  direction: -1 | 1
) => {
  const index = tabs.findIndex(tab => tab.type === type)
  const target = index + direction
  if (index < 0 || target < 0 || target >= tabs.length) return tabs

  const next = [...tabs]
  ;[next[index], next[target]] = [next[target], next[index]]
  return next
}

export const reorderTabOptions = (
  tabs: RateCardsConfigTabOption[],
  sourceIndex: number,
  destinationIndex: number
) => {
  if (
    sourceIndex < 0 ||
    destinationIndex < 0 ||
    sourceIndex >= tabs.length ||
    destinationIndex >= tabs.length
  ) {
    return tabs
  }

  const next = [...tabs]
  const [moved] = next.splice(sourceIndex, 1)
  next.splice(destinationIndex, 0, moved)
  return next
}
